module.exports = __webpack_public_path__ + "static/img/4.128ec98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/4.png
// module id = 8y5t
// module chunks = 0